import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface ITh {
  textAlign?: string;
}

export const Th = styled.th<ITh>`
  position: relative;
  padding: 10px;
  text-align: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.textAlign ? props.textAlign : "left")
  };
  vertical-align: middle;
  font-size: 12px;
  text-transform: uppercase;
  line-height: 14px;
  font-weight: normal;
  color: ${withVar(DesignToken.ContentBasicSecondary)};
`;

interface ITd {
  textAlign?: string;
}

export const Td = styled.td<ITd>`
  padding: 10px;
  text-align: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.textAlign ? props.textAlign : "left")
  };
  font-size: 14px;
  font-weight: normal;
  line-height: 1.43;
`;
